import React from 'react';
import Moment from 'moment';

import Button from '@material-ui/core/Button';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

export default (props) => {
  const url = props.config.liveStream.videoUrl;
  const videoId = props.config.liveStream.videoId;
  const title = props.config.liveStream.videoTitle;
  const startDate = Moment(props.config.liveStream.startDate).valueOf();
  const endDate = Moment(props.config.liveStream.endDate).valueOf();
  const now = new Date().getTime();
  const isLive = ((startDate <= now) && (now < endDate));
  return (
    <>
    { isLive &&
      <Button size="small" variant="contained" color="primary" disableElevation startIcon={<PlayCircleOutlineIcon />} onClick={e => props.setVideoSrc(url, videoId, title)} style={{margin: "5px 0 0 0", width: "100%"}}>watch&nbsp;<b>{props.config.name}</b>&nbsp;live now ... </Button>
    }
    </>
  );
}
